import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class AntiSpamPane extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
    this.saving = false;
    this.error = '';
    this.saved = false;
    this.settings = {
      enabled: true,
      monitor_all_users: false,
      monitor_post_count: 5,
      monitor_hours_old: 24,
      detect_phones: true,
      detect_emails: true,
      detect_urls: true,
      spam_threshold: 50,
      flag_threshold: 30,
      auto_unapprove: true,
      auto_flag: true,
      allowed_domains: '',
      blocked_words: '',
      advanced_block_patterns: '[]'
    };
    this.load();
  }
  api(path) {
    return String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '') + path;
  }
  async load() {
    if (this.loading) return;
    this.loading = true;
    this.error = '';
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/anti-spam')
      });
      this.settings = {
        ...this.settings,
        ...(data.settings || {})
      };
    } catch (e) {
      this.error = 'Impossible de charger les réglages anti-spam.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  async save() {
    if (this.saving) return;
    this.saving = true;
    this.saved = false;
    this.error = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/anti-spam'),
        body: {
          settings: this.settings
        }
      });
      this.settings = {
        ...this.settings,
        ...(data.settings || {})
      };
      this.saved = true;
    } catch (e) {
      this.error = e?.response?.error || 'Impossible d’enregistrer les réglages anti-spam.';
    } finally {
      this.saving = false;
      m.redraw();
    }
  }
  toggle(key, label, help) {
    if (help === void 0) {
      help = '';
    }
    return m('.ValAntiSpam-field.ValAntiSpam-field--toggle', [m('label', [m('input', {
      type: 'checkbox',
      checked: !!this.settings[key],
      onchange: e => {
        this.settings[key] = e.target.checked;
        this.saved = false;
      }
    }), m('span', label)]), help ? m('.helpText', help) : null]);
  }
  number(key, label, help) {
    if (help === void 0) {
      help = '';
    }
    return m('.ValAntiSpam-field', [m('label', label), m('input.FormControl', {
      type: 'number',
      min: 0,
      value: this.settings[key],
      oninput: e => {
        this.settings[key] = Number(e.target.value);
        this.saved = false;
      }
    }), help ? m('.helpText', help) : null]);
  }
  textarea(key, label, help, rows) {
    if (help === void 0) {
      help = '';
    }
    if (rows === void 0) {
      rows = 4;
    }
    return m('.ValAntiSpam-field', [m('label', label), m('textarea.FormControl', {
      rows,
      value: this.settings[key],
      oninput: e => {
        this.settings[key] = e.target.value;
        this.saved = false;
      }
    }), help ? m('.helpText', help) : null]);
  }
  view() {
    if (this.loading) {
      return m('.ValModerationPane.ValAntiSpam', 'Chargement…');
    }
    return m('.ValModerationPane.ValAntiSpam', [m('h2', 'Anti-spam'), m('p.helpText', 'Réglages du filtrage de contenu FoF Anti Spam. ' + 'StopForumSpam et les actions destructrices restent réservés à l’administration.'), this.error ? m('.Alert.Alert--error', this.error) : null, this.saved ? m('.Alert.Alert--success', 'Réglages enregistrés.') : null, m('.ValAntiSpam-section', [m('h3', 'Surveillance'), this.toggle('enabled', 'Activer le filtrage de contenu'), this.toggle('monitor_all_users', 'Surveiller tous les utilisateurs', 'Sinon, seuls les comptes récents correspondant aux critères ci-dessous sont surveillés.'), this.number('monitor_post_count', 'Nombre de premiers messages surveillés'), this.number('monitor_hours_old', 'Ancienneté maximale du compte surveillé (heures)')]), m('.ValAntiSpam-section', [m('h3', 'Détections'), this.toggle('detect_urls', 'Détecter les URL'), this.toggle('detect_emails', 'Détecter les adresses e-mail'), this.toggle('detect_phones', 'Détecter les numéros de téléphone')]), m('.ValAntiSpam-section', [m('h3', 'Seuils et actions'), this.number('flag_threshold', 'Seuil de signalement'), this.number('spam_threshold', 'Seuil de spam / dépublication'), this.toggle('auto_flag', 'Créer automatiquement un signalement'), this.toggle('auto_unapprove', 'Dépublier automatiquement le contenu considéré comme spam')]), m('.ValAntiSpam-section', [m('h3', 'Listes'), this.textarea('allowed_domains', 'Domaines autorisés', 'Domaines qui ne contribuent pas au score de spam.'), this.textarea('blocked_words', 'Mots bloqués'), this.textarea('advanced_block_patterns', 'Motifs avancés', 'Configuration JSON de FoF Anti Spam.', 6)]), m('.ValAntiSpam-actions', [m('button.Button.Button--primary', {
      type: 'button',
      disabled: this.saving,
      onclick: () => this.save()
    }, this.saving ? 'Enregistrement…' : 'Enregistrer')])]);
  }
}